import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { theme, cardStyle, inputStyle, labelStyle, tdStyle, thStyle, statCard } from '../theme';

const AuditLogPage = ({ API_BASE }) => {
  const [tab, setTab] = useState('audit');
  const [logs, setLogs] = useState([]);
  const [logins, setLogins] = useState([]);
  const [summary, setSummary] = useState({ total:0, todayCount:0, byAction:[] });
  const [filters, setFilters] = useState({ entity:'', action:'', from:'', to:'' });
  const [dbStats, setDbStats] = useState(null);

  const fetchAll = async () => {
    try {
      const params = new URLSearchParams();
      if (filters.entity) params.set('entity', filters.entity);
      if (filters.action) params.set('action', filters.action);
      if (filters.from)   params.set('from', filters.from);
      if (filters.to)     params.set('to', filters.to);
      const [l, s, lg] = await Promise.all([
        axios.get(`${API_BASE}/audit?${params.toString()}`),
        axios.get(`${API_BASE}/audit/summary`),
        axios.get(`${API_BASE}/audit/logins`),
      ]);
      setLogs(l.data); setSummary(s.data); setLogins(lg.data);
    } catch(e){}
  };

  const fetchDbStats = async () => {
    try { const r = await axios.get(`${API_BASE}/admin/db-stats`); setDbStats(r.data); } catch(e){}
  };

  useEffect(() => { fetchAll(); fetchDbStats(); }, []); // eslint-disable-line

  const fmtDateTime = d => d ? new Date(d).toLocaleString('en-IN',{day:'2-digit',month:'short',hour:'2-digit',minute:'2-digit'}) : '—';

  const tabBtn = (key, label) => (
    <button onClick={()=>setTab(key)}
      style={{padding:'9px 20px', borderRadius:'8px', border:'none', cursor:'pointer', fontWeight:'600', fontSize:'0.86rem',
        backgroundColor: tab===key ? theme.primary : '#e9ecef', color: tab===key ? 'white' : '#555'}}>
      {label}
    </button>
  );

  const actionColors = {
    CREATE: theme.success, UPDATE: theme.info, DELETE: theme.danger,
    LOGIN: theme.purple, LOGOUT: '#6b7785',
  };

  return (
    <div>
      <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'14px', marginBottom:'20px'}}>
        <div style={statCard}><span style={{fontSize:'0.78rem', color:theme.textMuted, fontWeight:'600', textTransform:'uppercase'}}>Total Logs</span>
          <h2 style={{margin:'4px 0 0', color:theme.navy, fontSize:'1.4rem', fontWeight:'700'}}>{summary.total}</h2></div>
        <div style={statCard}><span style={{fontSize:'0.78rem', color:theme.textMuted, fontWeight:'600', textTransform:'uppercase'}}>Today's Activity</span>
          <h2 style={{margin:'4px 0 0', color:theme.info, fontSize:'1.4rem', fontWeight:'700'}}>{summary.todayCount}</h2></div>
        <div style={statCard}><span style={{fontSize:'0.78rem', color:theme.textMuted, fontWeight:'600', textTransform:'uppercase'}}>Collections</span>
          <h2 style={{margin:'4px 0 0', color:theme.purple, fontSize:'1.4rem', fontWeight:'700'}}>{dbStats?.collections || '—'}</h2></div>
      </div>

      <div style={{display:'flex', gap:'8px', marginBottom:'20px'}}>
        {tabBtn('audit', 'Audit Log')}
        {tabBtn('logins', 'Login History')}
        {tabBtn('db', 'Database Stats')}
        {tabBtn('exports', 'Data Export')}
      </div>

      {/* Audit Log */}
      {tab === 'audit' && (
        <div style={cardStyle}>
          <div style={{display:'flex', gap:'10px', marginBottom:'16px', flexWrap:'wrap', alignItems:'flex-end'}}>
            <div><label style={labelStyle}>Entity</label>
              <select value={filters.entity} onChange={e=>setFilters({...filters, entity:e.target.value})} style={{...inputStyle, width:'auto'}}>
                <option value="">All</option>
                {['Patient','Appointment','Treatment','Bill','Payment','Prescription'].map(e => <option key={e} value={e}>{e}</option>)}
              </select>
            </div>
            <div><label style={labelStyle}>Action</label>
              <select value={filters.action} onChange={e=>setFilters({...filters, action:e.target.value})} style={{...inputStyle, width:'auto'}}>
                <option value="">All</option>
                {['CREATE','UPDATE','DELETE','LOGIN','LOGOUT'].map(a => <option key={a} value={a}>{a}</option>)}
              </select>
            </div>
            <div><label style={labelStyle}>From</label><input type="date" value={filters.from} onChange={e=>setFilters({...filters, from:e.target.value})} style={{...inputStyle, width:'auto'}}/></div>
            <div><label style={labelStyle}>To</label><input type="date" value={filters.to} onChange={e=>setFilters({...filters, to:e.target.value})} style={{...inputStyle, width:'auto'}}/></div>
            <button onClick={fetchAll} style={{padding:'10px 18px', backgroundColor:theme.primary, color:'white', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'600'}}>Filter</button>
          </div>
          {logs.length === 0 ? <p style={{color:'#aaa', textAlign:'center', padding:'40px'}}>No audit logs yet</p> : (
            <div style={{maxHeight:'500px', overflowY:'auto'}}>
              <table style={{width:'100%', borderCollapse:'collapse'}}>
                <thead><tr><th style={thStyle}>Time</th><th style={thStyle}>User</th><th style={thStyle}>Action</th><th style={thStyle}>Entity</th><th style={thStyle}>Details</th></tr></thead>
                <tbody>{logs.map(l => (
                  <tr key={l._id}>
                    <td style={tdStyle}>{fmtDateTime(l.createdAt)}</td>
                    <td style={tdStyle}>{l.userName || '—'}</td>
                    <td style={tdStyle}><span style={{padding:'2px 8px', borderRadius:'10px', fontSize:'0.72rem', fontWeight:'700',
                      backgroundColor:(actionColors[l.action]||'#aaa')+'18', color:actionColors[l.action]||'#aaa'}}>{l.action}</span></td>
                    <td style={tdStyle}>{l.entity || '—'}</td>
                    <td style={tdStyle}>{l.details || '—'}</td>
                  </tr>
                ))}</tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {/* Login History */}
      {tab === 'logins' && (
        <div style={cardStyle}>
          {logins.length === 0 ? <p style={{color:'#aaa', textAlign:'center', padding:'40px'}}>No login history</p> : (
            <table style={{width:'100%', borderCollapse:'collapse'}}>
              <thead><tr><th style={thStyle}>Time</th><th style={thStyle}>User</th><th style={thStyle}>Action</th><th style={thStyle}>IP</th></tr></thead>
              <tbody>{logins.map(l => (
                <tr key={l._id}>
                  <td style={tdStyle}>{fmtDateTime(l.createdAt)}</td>
                  <td style={tdStyle}><strong>{l.userName||'—'}</strong></td>
                  <td style={tdStyle}><span style={{padding:'2px 8px', borderRadius:'10px', fontSize:'0.72rem', fontWeight:'700',
                    backgroundColor: l.action==='login'?theme.success+'18':l.action==='failed'?theme.danger+'18':'#e5e7eb',
                    color: l.action==='login'?theme.success:l.action==='failed'?theme.danger:'#374151'}}>{l.action}</span></td>
                  <td style={tdStyle}>{l.ipAddress||'—'}</td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>
      )}

      {/* DB Stats */}
      {tab === 'db' && dbStats && (
        <div style={cardStyle}>
          <h3 style={{margin:'0 0 16px', color:theme.navy}}>Database Collections ({dbStats.collections})</h3>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(200px, 1fr))', gap:'12px'}}>
            {Object.entries(dbStats.stats).sort((a,b)=>b[1]-a[1]).map(([name, count]) => (
              <div key={name} style={{padding:'14px', backgroundColor:'#f8f9fa', borderRadius:'10px', display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span style={{fontSize:'0.85rem', color:theme.navy, fontWeight:'500'}}>{name}</span>
                <span style={{fontSize:'1.1rem', color:theme.primary, fontWeight:'700'}}>{count}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Data Export */}
      {tab === 'exports' && (
        <div style={cardStyle}>
          <h3 style={{margin:'0 0 16px', color:theme.navy}}>Export Data as CSV</h3>
          <div style={{display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(220px, 1fr))', gap:'14px'}}>
            {[
              { label:'Patients',     url:`${API_BASE}/admin/export/patients`,     icon:'👥' },
              { label:'Bills',        url:`${API_BASE}/admin/export/bills`,         icon:'🧾' },
              { label:'Appointments', url:`${API_BASE}/admin/export/appointments`,  icon:'📅' },
              { label:'Treatments',   url:`${API_BASE}/admin/export/treatments`,    icon:'🦷' },
            ].map(exp => (
              <div key={exp.label} onClick={()=>window.open(exp.url,'_blank')}
                style={{...cardStyle, cursor:'pointer', textAlign:'center', padding:'24px', borderTop:`4px solid ${theme.primary}`}}
                onMouseEnter={e=>e.currentTarget.style.transform='translateY(-2px)'}
                onMouseLeave={e=>e.currentTarget.style.transform='translateY(0)'}>
                <div style={{fontSize:'2rem', marginBottom:'8px'}}>{exp.icon}</div>
                <div style={{fontWeight:'700', color:theme.navy}}>{exp.label}</div>
                <div style={{fontSize:'0.78rem', color:theme.textMuted, marginTop:'4px'}}>Download CSV</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AuditLogPage;
